<template>    
    <section class="files-gallery">  
        <files-image-display 
                @emClicked="emFigureClicked"
                :class="{clickable: isClickable}"
                :img="listing[position].uri"
                :caption="caption" 
                :animate="animate" />
        
        <template v-if="listing && listing.length > 1 && pageable">
            <button class="prev" @click="ciPrev">&lt;</button>
            <button class="next" @click="ciNext">&gt;</button> 
        </template>

        <template v-if="listing && listing.length > 1 && selectable">            
            <ul>
                <li v-for="(temp, index) in listing" 
                        @click="ciSelect(index)"
                        :key="temp.id" >
                    <files-image-display 
                            :img="listing[index].uri"
                            :caption="listing[index].caption" />                    
                </li>
            </ul>
        </template>
    </section>
</template>

<script>
import FilesImageDisplay from './FilesImageDisplay'
export default {
    components: {
        FilesImageDisplay
    },
    computed: {
        focus() {
            return this.listing[this.position]
        },
        isClickable() {
            return this.listing[this.position].link.length > 0
        }
    },
    props: {
        listing: {
            type: [Boolean,Array],
            default: false
        },
        settings: {
            type: Object,
            default: function() {
                return false
            }
        },
        selectable: {
            type: Boolean,
            default: false
        },
        pageable: {
            type: Boolean,
            default: false
        },
        animate: {
            type: Boolean,
            default: false
        }
    },
    data:() => ({
        position: 0,
        ref: null,
        caption: false
    }),
    methods: {
        ciPrev(userClick = true) {
            if (userClick)
                this.killSlideshow()
            this.caption = false
            setTimeout(() => {
                this.position = this.position == 0
                    ? this.listing.length -1
                    : --this.position
                this.setCaption()
            },100)
        },
        ciNext(userClick = true) {            
            if (userClick)
                this.killSlideshow()
            this.caption = false
            setTimeout(() => {
                this.position = this.position >= this.listing.length - 1
                    ? 0
                    : ++this.position
                this.setCaption()
            },100)
        },
        ciSelect(index) {
            this.killSlideshow()
            this.position = index
        },
        emFigureClicked() {
            if (this.listing[this.position].link.length == 0) return            
            if (this.listing[this.position].link.startsWith('http'))
                window.location = this.listing[this.position].link
            else 
                this.$router.push(this.listing[this.position].link)
        },
        killSlideshow() {
            if (this.ref == null) return
            clearInterval(this.ref)
        },
        setCaption() {
            this.caption = this.listing[this.position].caption.length == 0
                ? false
                : this.listing[this.position].caption

        }
    },
    mounted() {
        this.setCaption()    
        if (this.listing.length < 2) return

        const config = {
            ...{
                period: 4000,
                repeat: true
            },
            ...this.settings.slideshow
        }

        let count = config.repeat ? -1 : this.listing.length
        this.ref = setInterval(() => {
            this.ciNext(false)
            if (--count == 0)
                this.killSlideshow()
        }, config.period)
    }
}
</script>